import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';

class CompanyUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      contact: '',
      role: '',
      profileId: '',
      userList: [],
      roleList: [],
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();

    const user = StorageService.getSession('user_info');
    const selected_org = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_API_URL;
    const data = {
      session_key: user.session_key,
      Id: this.props.data.userId,
      ProfileID: this.state.profileId,
      Name: this.state.name,
      Contact: this.state.contact,
      Role: this.state.role,
    };

    axios
      .post(url + ':3000/v1/company/updateUser', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        if (this.props.match.params.id === selected_org.CompanyID) {
          let sData = selected_org;
          if (sData) {
            sData.Role = this.state.role;
          }
          StorageService.setSession('selected_org', sData);
        }

        this.props.closeModal(
          <MdDone />,
          'User updated successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  };

  getRoleList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/user/roles', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ roleList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    this.getRoleList();
    const user = this.props.data.userList.find(
      e => e.Id === this.props.data.userId,
    );
    this.setState({
      profileId: user.ProfileID,
      name: user.Name,
      contact: user.Contact,
      role: user.Role,
    });
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>
          User Information
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="name">Name</Label>
                <Input
                  type="text"
                  name="name"
                  value={this.state.name}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="contact">Contact</Label>
                <Input
                  type="text"
                  name="contact"
                  value={this.state.contact}
                  onChange={this.changeHandler}
                />
              </FormGroup>
              <FormGroup>
                <Label for="role">Role</Label>
                <Input
                  type="select"
                  name="role"
                  value={this.state.role}
                  onChange={this.changeHandler}
                  required
                >
                  <option value=""></option>
                  {this.state.roleList.length > 0 &&
                    this.state.roleList.map((item, index) => {
                      return (
                        <option key={index} value={item.role}>
                          {item.role}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default CompanyUserForm;
